import React from 'react';
import PropTypes from 'prop-types';
import HTMLToReact from 'html-react-parser';
import { cdn } from '@deporvillage/picture-component';
import { Config, I18nContext } from '@deporvillage/utils-library-component';

import styles from './BannerGeoIp.module.scss';

const BannerType = {
    Delivery: 1,
    Store: 2,
};

/* eslint-disable no-undef */
const base64 = (str) => {
    try {
        return btoa(str);
    } catch (err) {
        /* istanbul ignore next */
        return Buffer.from(str).toString('base64');
    }
};
/* eslint-enable no-undef */

const BannerGeoIp = ({ type, url, extension, country }) => {
    const elem = React.useRef(null);
    const { cdn: cdnConfig } = React.useContext(Config);
    const { translate } = React.useContext(I18nContext);

    /* eslint-disable-next-line no-undef */
    const handleClose = () => window.dispatchEvent(new CustomEvent('geo-ip:close'));

    React.useEffect(() => {
        /* eslint-disable-next-line no-undef */
        window.dispatchEvent(
            new CustomEvent('countries:loaded', { detail: { elem: elem.current, uenc: null } }),
        );
    }, []);

    return (
        <div className={styles[`banner-geo-ip-component`]} ref={elem}>
            {type === BannerType.Store ? (
                <div className={styles['banner-geo-ip-wrapper']}>
                    <div>
                        {HTMLToReact(
                            translate(`geo_ip.message_country`, {
                                store: `deporvillage.${extension}`,
                            }),
                        )}
                    </div>

                    <div className={styles['btn-close']} onClick={handleClose}>
                        {translate(`geo_ip.close`)}
                    </div>

                    <div
                        className={styles['btn-click']}
                        data-location={base64(`${url}/?country=${country}`)}
                    >
                        {HTMLToReact(
                            translate(`geo_ip.cta_go`, { store: `deporvillage.${extension}` }),
                        )}
                        <span className={`${styles['icon']} icon icon-arrow-right-keyboard`} />
                    </div>
                </div>
            ) : null}

            {type === BannerType.Delivery ? (
                <div className={styles['banner-geo-ip-wrapper']}>
                    <div>
                        {cdnConfig &&
                            HTMLToReact(
                                translate(`geo_ip.message_delivery`, {
                                    code: country,
                                    flag: cdn(
                                        {
                                            src: `static/flags/${country.toLowerCase()}.png`,
                                            width: 16,
                                            height: 16,
                                        },
                                        cdnConfig,
                                    ),
                                    flag2x: cdn(
                                        {
                                            src: `static/flags/${country.toLowerCase()}.png`,
                                            width: 16,
                                            height: 16,
                                            dpr: 2,
                                        },
                                        cdnConfig,
                                    ),
                                    country: translate(`countries.${country.toLowerCase()}`),
                                }),
                            )}
                    </div>

                    <div className={styles['btn-close']} onClick={handleClose}>
                        {translate(`geo_ip.close`)}
                    </div>

                    <div
                        className={styles['btn-click']}
                        data-location={base64(`${url}/?country=${country}`)}
                    >
                        {HTMLToReact(
                            translate(`geo_ip.cta_ship`, {
                                country: translate(`countries.${country.toLowerCase()}`),
                            }),
                        )}
                        <span className={`${styles['icon']} icon icon-arrow-right-keyboard`} />
                    </div>
                </div>
            ) : null}
        </div>
    );
};

BannerGeoIp.propTypes = {
    type: PropTypes.oneOf([BannerType.Delivery, BannerType.Store]),
    url: PropTypes.string,
    country: PropTypes.string,
    extension: PropTypes.string,
};

export default BannerGeoIp;
